export const variantConfig = {
  primary: 'text-primary bg-primary-container',
  info: 'text-info bg-info-container',
  success: 'text-success bg-success-container',
  warning: 'text-warning bg-warning-container',
  error: 'text-error bg-error-container',
  default: 'text-on-surface bg-surface-container'
}

export const variantConfigHelper = {
  primary: 'text-primary',
  info: 'text-info',
  success: 'text-success',
  warning: 'text-warning',
  error: 'text-error'
}

export const iconSizeConfig = {
  default: '20px',
  xs: '12px',
  sm: '16px'
}
